import { Component, OnInit, Input, Output, TemplateRef, EventEmitter, ContentChild } from '@angular/core';

@Component({
  selector: 'lib-modalform',
  templateUrl: './modalform.component.html',
  styleUrls: ['./modalform.component.css']
})
export class ModalformComponent implements OnInit {

  constructor() {
    this.textDir =  sessionStorage.getItem('textDir');
    console.log("this.textDir >>> "+this.textDir);
  }
  @Input() modalID: any;
  @Input() modalClass: string;
  @Input() modalTitle: any;
  @Input() modalInfo: any;

  @Input() viewType: string;
  @Input() btnSaveText: string;
  @Input() btnTextAllow: string;
  @Input() btnSaveStatus: boolean;
  @Input() btnAddText: string;
  @Input() btnAddStatus: boolean;
  @Input() btnSendText: string;
  @Input() btnSendStatus: boolean;
  @Input() btnCancelText: string;
  @Input() btnEditText: string;
  @Input() btnEditStatus: boolean;
  @Input() btnTextDeny: string;
  @Input() isTeacher = false;

  @Input() editLink: string;
  @Input() btnDeleteText: string;

  @Output()
  saveEvent: EventEmitter<boolean> = new EventEmitter();
  @Output()
  allowAccessEvent: EventEmitter<boolean> = new EventEmitter();
  @Output()
  allowAccessToUserEvent: EventEmitter<boolean> = new EventEmitter();
  @Output()
  cancelEvent: EventEmitter<boolean> = new EventEmitter();

  @Output()
  denyEvent: EventEmitter<boolean> = new EventEmitter();

  @Output()
  sendEvent: EventEmitter<boolean> = new EventEmitter();

  @Output()
  removeLogoEvent: EventEmitter<boolean> = new EventEmitter();

  @Output()
  enableArchiveEvent: EventEmitter<boolean> = new EventEmitter();

  @Output()
  evEnableEdit: EventEmitter<boolean> = new EventEmitter();

  @Output()
  evEnableDelete: EventEmitter<boolean> = new EventEmitter();

  @Output()
  addEvent: EventEmitter<boolean> = new EventEmitter();
  textDir:any;

  ngOnInit() {
    if (!this.btnCancelText) {
      this.btnCancelText = 'Cancel';
    }

    if (!this.viewType) {
      this.viewType = 'restricted';
    }
    
  }

  ngOnDestroy() {

  }

  edit() {
    this.viewType = 'edit';
  }

  save() {
    this.saveEvent.emit(true);
  }

  enableEdit() {
    this.evEnableEdit.emit(true);
  }

  enableDelete() {
    this.evEnableDelete.emit(true);
  }
  allowAccess(){
    this.allowAccessEvent.emit(true);
  }
  allowAccessToUser(){
    this.allowAccessToUserEvent.emit(true);
  }
  cancel() {
    this.cancelEvent.emit(true);
  }
  deny(){
    this.denyEvent.emit(true);
  }
  send() {
    this.sendEvent.emit(true);
  }

  removeLogo() {
    this.removeLogoEvent.emit(true);
  }

  enableArchive() {
    this.enableArchiveEvent.emit(true);
  }

  add() {
    this.addEvent.emit(true);
  }

  mouseHover()
  {
    // alert("mouseHover");
  }

  mouseout() {
    // alert("Adasdsad")

  }


}
